import { getStripeCustomerRequest } from '@domain/billing/stripe/stripe-customer';
import { createOrder } from '../order/order.state';
import { createMiddleware } from '../../../shared/redux';
import {
    changeOrderModalStep,
    changePaymentMethodModalStep,
    CLOSE_ORDER_MODAL,
    OPEN_CHANGE_PAYMENT_METHOD_MODAL,
    CLOSE_CHANGE_PAYMENT_METHOD_MODAL,
    OPEN_ORDER_MODAL,
} from './interface.state';
import { BILLING_CENTER } from '../center/center.constants';
import { getInitialOrderSimulation } from '../order/simulation/simulation.state';
import { getBillingDetailsRequest } from '../details';
import { getAddons } from '../../pricing/addon/addon.state';
import { getCurrencies } from '../../pricing/currency/currency.state';
import { getSubscriptionData } from '../subscription/subscription.state';
import { getPlans } from '../../pricing/plan/plan.state';

export const interfaceMiddlewares = createMiddleware({
    [OPEN_ORDER_MODAL]: (state, action) => {
        const isFromBillingCenter = action.payload.params.source === BILLING_CENTER;
        const data = isFromBillingCenter
            ? action.payload.params
            : getSubscriptionData(state);

        return [
            changeOrderModalStep({ simulation: true }),
            getPlans(),
            getAddons(),
            getCurrencies(),
            createOrder(data),
            getBillingDetailsRequest(),
        ];
    },
    [CLOSE_ORDER_MODAL]: () => [getInitialOrderSimulation()],
    [OPEN_CHANGE_PAYMENT_METHOD_MODAL]: () => [
        getBillingDetailsRequest(),
        getStripeCustomerRequest(),
        changePaymentMethodModalStep({ paymentMethod: true }),
    ],
    [CLOSE_CHANGE_PAYMENT_METHOD_MODAL]: () => [
        changePaymentMethodModalStep({ paymentMethod: true }),
    ],
});
